export enum ReportTypes {
  Excel = 1,
  PowerBi
}
